import { createExperiencesRequestBatcher } from './utils/create-experiences-request-batcher';
import { getHttpClient } from './utils/get-http-client';
/**
 * Creates a [[CxmRulesClient]] instance based on the provided configuration options.
 *
 * @param config The configuration options.
 * @returns The created [[CxmRulesClient]] instance.
 */
export const createCxmRulesClient = (config) => {
    const httpClient = getHttpClient(config);
    const experiencesRequestBatcher = createExperiencesRequestBatcher(config, httpClient);
    return {
        getExperiences: request => experiencesRequestBatcher.dispatchRequest(request),
        getSites: queryParams => httpClient.get('/v2/Site/nearest', { queryParams })
    };
};
//# sourceMappingURL=create-cxm-rules-client.js.map